import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NotificationSettings.css';
import { useTranslation } from 'react-i18next';
import { fetchNotificationSettings, saveNotificationSettings } from './NotificationSettingsApi';

const NotificationSettings = () => {
  const { t } = useTranslation();
  const [usageRange, setUsageRange] = useState('90-100');
  const [usageEmailEnabled, setUsageEmailEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    const loadSettings = async () => {
      setLoading(true);
      try {
        const data = await fetchNotificationSettings();
        if (!mounted) return;
        const allowed = ['30-49', '50-89', '90-100'];
        const safeRange = allowed.includes(data?.usageRange) ? data.usageRange : '90-100';
        setUsageRange(safeRange);
        setUsageEmailEnabled(Boolean(data?.emailEnabled));
      } catch (error) {
        if (!mounted) return;
        console.error('Error loading notification settings:', error);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    loadSettings();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSaveUsageSettings = async () => {
    const allowed = ['30-49', '50-89', '90-100'];
    if (!allowed.includes(usageRange)) {
      window.alert('Invalid usage range selected.');
      return;
    }
    setSaving(true);
    try {
      await saveNotificationSettings({
        usageRange,
        emailEnabled: usageEmailEnabled,
      });
      window.alert('Notification settings saved successfully.');
    } catch (error) {
      console.error('Error saving notification settings:', error);
      window.alert('Failed to save notification settings. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-vh-100 p-3 p-sm-4 p-md-5 text-secondary font-sans">
      <h1 className="text-muted mb-4">{t('notificationsSettings')}</h1>

      {/* Section 1: Service Usage */}
      <section className="p-4 mb-4" style={{ width:"70%" , borderColor: '#5fa2e4' , backgroundColor:"white" , borderRadius:"15px" , border:"1px solid blue"}}>
        <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 rounded mb-3" style={{ borderColor: '#5fa2e4' }}>
          <p className="mb-0 flex-grow-1" style={{ fontSize: "18px" , fontWeight:"bold" }}>
            {t('serviceUsageNotification')}
          </p>
          <select
            className="form-select form-select-sm custom-select-red"
            value={usageRange}
            onChange={(e) => setUsageRange(e.target.value)}
            disabled={loading || saving}
          >
            <option className="rgb-red bg-danger text-white" value="30-49">{t('percentageRange30_49')}</option>
            <option className="rgb-red bg-danger text-white" value="50-89">{t('percentageRange50_89')}</option>
            <option className="rgb-red bg-danger text-white" value="90-100">{t('percentageRange90_100')}</option>
          </select>

          <div className="d-flex align-items-center gap-3 ms-sm-auto mt-2 mt-sm-0 toggle-container">
            <label className="custom-toggle">
              <input
                type="checkbox"
                checked={usageEmailEnabled}
                onChange={(e) => setUsageEmailEnabled(e.target.checked)}
                disabled={loading || saving}
              />
              <span className="toggle-slider" />
              <span className="toggle-label">{t('email')}</span>
            </label>
            <label className="custom-toggle" style={{ display: 'none' }}>
              <input type="checkbox" defaultChecked />
              <span className="toggle-slider" />
              <span className="toggle-label">{t('sms')}</span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-end pt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={handleSaveUsageSettings}
            disabled={loading || saving}
          >
            {saving ? 'Saving...' : t('save')}
          </button>
        </div>
      </section>

      {/* Section 2: Subscription Request */}
      <section className="p-4" style={{ width:"70%",borderColor: '#9DC6CE' , backgroundColor:"white", borderRadius:"15px" , border:"1px solid blue"}}>
        <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 rounded mb-3" style={{ borderColor: '#D9E6E9' }}>
          <p className="mb-0 flex-grow-1" style={{ fontSize: "18px" , fontWeight:"bold" }}>
            {t('subscriptionRequestNotification')}
          </p>
          <select className="form-select form-select-sm custom-select-green">
            <option className="rgb-green bg-success text-white">{t('approved')}</option>
            <option className="rgb-green bg-success text-white">{t('pending')}</option>
            <option className="rgb-green bg-success text-white">{t('rejected')}</option>
          </select>

          <div className="d-flex align-items-center gap-3 ms-sm-auto mt-2 mt-sm-0 toggle-container">
            <label className="custom-toggle">
              <input type="checkbox" defaultChecked />
              <span className="toggle-slider" />
              <span className="toggle-label">{t('email')}</span>
            </label>
            <label className="custom-toggle" style={{ display: 'none' }}>
              <input type="checkbox" defaultChecked />
              <span className="toggle-slider" />
              <span className="toggle-label">{t('sms')}</span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-end pt-3">
          <button className="btn btn-outline-primary btn-sm">{t('save')}</button>
        </div>
      </section>
    </div>
  );
};

export default NotificationSettings;